module.exports = __webpack_public_path__ + "static/img/Harrison-Wilson.964e7ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harrison-Wilson.jpg
// module id = /O4B
// module chunks = 0